import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font } from '~styles/theme.stylex';
export const styles = {
  section: {
    marginTop: "x1c4vshn",
    $$css: true
  },
  header: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    marginBottom: "x1gr9t9r",
    $$css: true
  },
  label: {
    fontSize: "xboafo0",
    fontWeight: "x1sl8krj",
    letterSpacing: "x2ujxvm",
    textTransform: "xtvhhri",
    color: "xarw3lm",
    $$css: true
  }
};